import { EUserFormError, EUserFormType } from 'core/model/enums/users.enum';
import { IUserDetailRequest, TUserFiltersForm } from 'core/model/interfaces/users';

export const USER_FORM_ERRORS_MESSAGES = {
  [EUserFormType.EDIT]: 'Error inesperado mientras se editaba un usuario',
  [EUserFormType.ACTIVATE]: 'Error inesperado mientras se registraba un usuario',
};

export const USER_ERROR_MESSAGES = {
  [EUserFormError.NO_RESULTS_FOUND]: 'No se encontró el documento. Valida que los datos sean correctos.',
  [EUserFormError.USER_DEACTIVATED]: 'El usuario se encuentra inactivo.',
  [EUserFormError.USER_ALREADY_ACTIVATED]: 'El documento ya se encuentra registrado',
  [EUserFormError.INVALID_PRICE_LIST]: 'No es posible completar el registro.',
  [EUserFormError.NO_ADDRESSES]: 'No es posible completar el registro.',
};

export const USERS_PAGE_TITLE = 'Gestión de usuarios';

export const USERS_PAGE_SUBTITLE = 'Crea, edita y gestiona los datos de los usuarios.';

export const USERS_FILTERS_FORM_ATTRIBUTES: Record<keyof TUserFiltersForm, keyof TUserFiltersForm> = {
  documents: 'documents',
  query: 'query',
};

export const USER_DETAILS_FORM_ATTRIBUTES: Record<keyof IUserDetailRequest, keyof IUserDetailRequest> = {
  id: 'id',
  fullName: 'fullName',
  externalId: 'externalId',
  birthDate: 'birthDate',
  isLegalConsentAccepted: 'isLegalConsentAccepted',
  isPrivacyConsentAccepted: 'isPrivacyConsentAccepted',
  phone: 'phone',
  customers: 'customers',
  supportTicketId: 'supportTicketId',
  documentType: 'documentType',
  documentNumber: 'documentNumber',
};

export const USER_DOCUMENT_TYPES = [
  {
    label: 'DNI',
    value: 'DNI',
  },
  {
    label: 'RUC',
    value: 'RUC',
  },
  {
    label: 'CE',
    value: 'CE',
  },
];

export const USERS_DOCUMENTS_INPUT = {
  name: USERS_FILTERS_FORM_ATTRIBUTES.documents,
  labelText: 'Número(s) de documento',
  placeholder: 'Buscar por n° de documento',
  helperText: 'Ten en cuenta que puedes iniciar tu búsqueda utilizando un único criterio a la vez.',
};

export const USERS_QUERY_INPUT = {
  name: USERS_FILTERS_FORM_ATTRIBUTES.query,
  labelText: 'Nombre del cliente / Razón Social',
  placeholder: 'Buscar por nombre o razón social',
};
